import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'labs',
  templateUrl: 'labs.component.html',
  styleUrls: ['./labs.component.scss']
})

export class LabsComponent implements OnInit {
  loading = false;
  errors = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/labs/labs.component.ts